import { CommitmentKpi } from '../../coaching-base/general';

import { GoalCategoryView } from './goal-category-view.model';

export interface GoalListState {
    /**
     * static order:
     * - draft
     * - active-for-this-metric
     * - active-for-other-metric
     * - recently-closed
     * - disputed
     */
    categories?: GoalCategoryView[];

    /** @deprecated */
    isOriginalWithDraftTrackingIdMap: { [trackingId: number]: boolean };

    selectedCommitmentKpi?: CommitmentKpi;
    sortOrder?: 'asc' | 'desc';
}

export const defaultState = (): GoalListState => ({
    isOriginalWithDraftTrackingIdMap: {},
});
